import 'bootstrap/dist/css/bootstrap.min.css';
import PrivateRoute from 'pages/Verify/PrivateRoute';
import Verify from 'pages/Verify/Verify';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';

function App() {
  return (
    <Router>
      <Switch>
        <PrivateRoute path="/dashboard" component={() => <Home />} />
        <Route path="/" component={Verify} />
        <Route path="/verify" component={Verify} />
      </Switch>
    </Router>
  );
}

export default App;
